import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-content-image-redesign',
    templateUrl: './content-image-redesign.component.html',
    styleUrls: ['./content-image-redesign.component.scss']
})
export class ContentImageRedesignComponent {

    @Input() image = '';

    @Input() imageAlt = '';

    @Input() title = '';

    @Input() paragraphs: string[] = [];

    @Input() imageLeft = true;

    trackByIndex(index: number): number {
        return index;
    }

}